/* eslint-disable eqeqeq */
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import {checkToken} from '../api/modules/auth'
import swal from 'sweetalert'

/**
 * Hook ini dibuat untuk mengecek token yang tersimpan di local storage
 * yang digunakan dibeberapa page component pada legency code.
 *
 * @note: Mungkin kedepannya hook ini tidak akan digunakan lagi.
 */
export const useValidateToken = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()

  // FIXME: refactor this function
  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  // FIXME: refactor this function
  useEffect(() => {
    const token = localStorage.getItem('token')

    const cektoken = () => {
      if (token != undefined) {
        checkToken(token?.replace(/['"]+/g, ''))
          .then((res) => {
            if (localStorage.getItem('credential') == undefined) {
              localStorage.setItem('credential', res.data.credential)
            }

            const test = atob(res.data.credential)
            const temp = JSON.parse(test)

            localStorage.setItem('accesses', JSON.stringify(res.data.accesses))

            if (temp.role_flag == null) {
              localStorage.setItem(
                'username',
                temp.customer?.title != null
                  ? temp.customer?.title + ' ' + temp.customer?.name
                  : temp.customer?.name
              )
            } else {
              localStorage.setItem('username', temp.name)
            }

            localStorage.setItem('credential-decoded', test)

            if (temp.customer_code != '' || temp.customer_code != null) {
              localStorage.setItem('cust-code', temp.customer_code)
            }

            if (
              temp.customer?.customer_account_group != '' ||
              temp.customer?.customer_account_group != null
            ) {
              localStorage.setItem('cust-group', temp.customer?.customer_account_group)
            }
          })
          .catch((err) => {
            if (err.code === 'ERR_NETWORK' || err.code === 'ERR_BAD_REQUEST') {
              removeStorage()
              navigate('/auth')
              return
            }

            if (err.response.data.message != 'Token not found' && err.response.data.error == true) {
              window.location.reload()
            } else if (err.response.data.error) {
              swal({
                title: err.response.data.message,
                icon: 'error',
              }).then(() => {
                removeStorage()
                navigate('/auth')
              })
            }
          })
      } else {
        swal({
          title: t('Token Not Found'),
          timer: 2000,
          icon: 'error',
        }).then(() => {
          removeStorage()
          navigate('/auth')
        })
      }
    }
    cektoken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
